import { newImport } from '@/utils/index.js'

export default [
  // 首页
  {
    path: '/home',
    name: 'Home',
    component: () => newImport('home/index'),
    meta: {
      title: '首页'
    }
  }
]



// WEBPACK FOOTER //
// ./src/routers/module/main.js